import {Image} from "../data/Image";

export namespace ImageUtils {

    export const loadImageData = (image: Image, preferPreviewImage: boolean = false) => {
        if (!preferPreviewImage) return image.data;
        return image.previewData ?? image.data;
    }
}
